import { TimelapseFrameOrientation, TimelapseFrameTileMetadata } from '../../models/timelapse.models';

/**
 * Minimal frame descriptor used by the 360 viewer timelapse sequence manager.
 * Mirrors `TimelapseFrame` shape but decoupled from Angular-facing fields
 * so the manager can be consumed directly from the viewer.
 */
export interface TimelapseSequenceFrame {
  id: string;
  imageUrl: string;
  thumbnailUrl?: string;
  tiles?: TimelapseFrameTileMetadata[];
  tileSourceMode?: 'standard' | 'blurred';
  initialOrientation?: TimelapseFrameOrientation;
}

/**
 * Configuration for the timelapse sequence manager.
 */
export interface TimelapseSequenceConfig {
  /**
   * Number of frames to prefetch ahead of the active index.
   * Defaults to 5 if not provided.
   */
  prefetchAheadCount?: number;

  /**
   * Number of frames to eagerly warm up on initial load.
   * Defaults to `prefetchAheadCount` when omitted.
   */
  warmupCount?: number;
}

/**
 * Snapshot of frame readiness used for debugging and diagnostics.
 */
export interface TimelapseFrameReadiness {
  id: string;
  isPrefetched: boolean;
  hasTiles: boolean;
  lastPrefetchedAt?: number;
}



